import { Box, BoxProps } from '@mui/material';
import theme from 'App.theme';
import { FC, ReactNode } from 'react';

type Props = {
  label: ReactNode;
  foregroundColor: string;
  backgroundColor: string;
  allowWrap?: boolean;
} & BoxProps;

export const Chip: FC<Props> = ({ label, foregroundColor, backgroundColor, allowWrap = false, sx, ...props }) => {
  return (
    <Box
      sx={{
        border: '2px solid',
        borderColor: foregroundColor,
        borderRadius: 12,
        backgroundColor: backgroundColor,
        padding: `2px ${theme.layout.spacing.small}`,
        fontWeight: 500,
        fontSize: 13,
        lineHeight: 1,
        color: foregroundColor,
        textAlign: 'center',
        alignContent: 'center',
        whiteSpace: allowWrap ? 'initial' : 'nowrap',
        width: allowWrap ? '120px' : 'auto',
        height: allowWrap ? '46px' : 'auto',
        ...sx,
      }}
      {...props}
    >
      {label}
    </Box>
  );
};

export default Chip;
